import { AxiosResponse } from "axios";
import { IQuestion, IUserBalance } from "../interfaces/question";
import http from "../services/http";

export default class QuestionService {
  async getRandomQuestion(): Promise<IQuestion> {
    try {
      const response: AxiosResponse = await http.get(
        `${process.env.REACT_APP_BASE_URL}questions/random`
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  async getUserBalance(): Promise<IUserBalance> {
    try {
      const response: AxiosResponse = await http.get(
        `https://ft66cexhj3.execute-api.eu-west-1.amazonaws.com/api/user/token`
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async getQuestion(questionId: number): Promise<IQuestion> {
    try {
      const response: AxiosResponse = await http.get(
        `${process.env.REACT_APP_BASE_URL}questions/${questionId}`
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}
